import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import PageSectionEmpty from "../../components/PageSectionEmpty/PageSectionEmpty"
import PageSectionSolo from "../../components/PageSectionSolo/PageSectionSolo"
import PageSectionSplitHalf from "../../components/PageSectionSplitHalf/PageSectionSplitHalf"
import PageSectionSplitThird from "../../components/PageSectionSplitThird/PageSectionSplitThird"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import { Container, Wrapper } from "./Story.styles"

const Story = () => {
   const language = useSelector((state) => state.environment.language)
   const { t } = useTranslation()
   const [currentSectionIndex, setCurrentSectionIndex] = useState(0)
   const [pageContents, setPageContents] = useState([])
   const [picturesLeft, setPicturesLeft] = useState([])
   const [picturesRight, setPicturesRight] = useState([])

   const handleScroll = (e) => {
      const scrollY = e.target.scrollTop
      const sectionHeight = window.innerHeight
      const index = Math.round(scrollY / sectionHeight)
      setCurrentSectionIndex(index)
   }

   useEffect(() => {
      const getContents = async () => {
         const res = await publicRequest.get("page-contents")
         setPageContents(res.data.filter((item) => item.page === "story"))
      }
      const getPictures = async () => {
         const res = await publicRequest.get("images")
         setPicturesLeft(
            res.data
               .filter((item) => item.section === "1")
               .sort((a, b) => a.name.localeCompare(b.name))
               .map((item) => item.imageLink)
         )
         setPicturesRight(
            res.data
               .filter((item) => item.section === "2")
               .sort((a, b) => a.name.localeCompare(b.name))
               .map((item) => item.imageLink)
         )
      }
      getContents()
      getPictures()
   }, [setPageContents])

   return (
      <>
         <Helmet>
            <title>{t("storyPage.meta.meta_title")}</title>
            <meta
               name="description"
               content={t("storyPage.meta.meta_description")}
            />
         </Helmet>
         <Container>
            <Navbar
               bgImageColor={
                  currentSectionIndex === 0 || currentSectionIndex === 4
                     ? "dark"
                     : "light"
               }
            />
            <Wrapper onScroll={handleScroll}>
               <PageSectionSolo
                  image={pageContents[0]?.imageCenter}
                  title={
                     language === "fr"
                        ? pageContents[0]?.titleFr
                        : pageContents[0]?.titleEn
                  }
                  text={
                     language === "fr"
                        ? pageContents[0]?.textFr
                        : pageContents[0]?.textEn
                  }
               />
               <PageSectionSplitHalf
                  image={pageContents[2]?.imageRight}
                  title={
                     language === "fr"
                        ? pageContents[2]?.titleFr
                        : pageContents[2]?.titleEn
                  }
                  text={
                     language === "fr"
                        ? pageContents[2]?.textFr
                        : pageContents[2]?.textEn
                  }
                  imageFirst={false}
               />
               <PageSectionSplitThird
                  patchworkLeft={picturesLeft}
                  patchworkRight={picturesRight}
                  title={
                     language === "fr"
                        ? pageContents[1]?.titleFr
                        : pageContents[1]?.titleEn
                  }
                  text={
                     language === "fr"
                        ? pageContents[1]?.textFr
                        : pageContents[1]?.textEn
                  }
               />
               <PageSectionSplitHalf
                  image={pageContents[3]?.imageLeft}
                  title={
                     language === "fr"
                        ? pageContents[3]?.titleFr
                        : pageContents[3]?.titleEn
                  }
                  text={
                     language === "fr"
                        ? pageContents[3]?.textFr
                        : pageContents[3]?.textEn
                  }
                  imageFirst
               />
               <PageSectionEmpty heroImageNumber={0} />
            </Wrapper>
         </Container>
      </>
   )
}

export default Story
